package com.iregained.site.components.sections.patients.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

// ==========================================
// PROTOCOL SECTION STYLES
// ==========================================

val ProtocolCardStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier
            .backgroundColor(Colors.White)
            .borderRadius(16.px)
            // A subtle, static border to define the card edge
            .border(1.px, LineStyle.Solid, palette.custom.divider)
            // A baseline shadow
            .boxShadow(0.px, 10.px, 25.px, color = palette.custom.darkText.toRgb().copyf(alpha = 0.05f))
            .transition(
                Transition.of("transform", 0.4.s),
                Transition.of("box-shadow", 0.4.s),
                Transition.of("border-color", 0.4.s)
            )
            // Setting up for the bottom accent border trick
            .position(org.jetbrains.compose.web.css.Position.Relative)
            .overflow(com.varabyte.kobweb.compose.css.Overflow.Hidden)
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier
            .translateY((-8).px) // Lift up on hover
            .border(1.px, LineStyle.Solid, palette.brand.primarySoft) // Soften border on hover
            .boxShadow(0.px, 20.px, 40.px, color = palette.brand.primary.toRgb().copyf(alpha = 0.15f))
    }
}

// A decorative bottom bar that expands when the card is hovered
val ProtocolCardBottomAccentStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier
            .position(org.jetbrains.compose.web.css.Position.Absolute)
            .bottom(0.px)
            .left(0.px)
            .height(6.px)
            .width(0.percent) // Hidden initially
            .backgroundColor(palette.brand.primary)
            .transition(Transition.of("width", 0.4.s))
    }
    // When the parent Card is hovered, expand this line
    cssRule("*:hover > &") {
        Modifier.width(100.percent)
    }
}

val ProtocolImageStyle = CssStyle {
    base {
        Modifier
            .transition(Transition.of("transform", 0.6.s))
    }
    // When the parent Card is hovered, slightly zoom the image
    cssRule("*:hover img") {
        Modifier.scale(1.05)
    }
}